import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ICommonPopupsProps, Popup } from '@gem/popups';

import { CallDevicesPreview } from './CallDevicesPreview/CallDevicesPreview';
import { CallPreviewLoader } from './CallPreviewLoader/CallPreviewLoader';
import { useCallPreviewPresenter } from './RoomCallPreviewPopup.presenter';
import styles from './RoomCallPreviewPopup.styles.m.css';
import { WebinarInvitation } from './WebinarInvitation/WebinarInvitation';

interface IRoomCallPreviewPopupProps {
  channelId: string;
}

export const RoomCallPreviewPopup: FC<ICommonPopupsProps<IRoomCallPreviewPopupProps>> = observer(
  (props) => {
    const presenter = useCallPreviewPresenter(props);

    return (
      <Popup
        className={styles.popup}
        isOpened={true}
        onClose={presenter.onClose}
      >
        {!presenter.isPreviewInitialized && <CallPreviewLoader isDarkMode={presenter.isDarkMode} />}
        {presenter.isShowDefaultPreview && <CallDevicesPreview presenter={presenter} />}
        {presenter.isShowWebinarPreview && <WebinarInvitation presenter={presenter} />}
      </Popup>
    );
  }
);
